<template>
  <div class="columns">
    <div class="column">
      <form-field-date-picker
        label="Accepted Date"
        v-model="form.buying_info_accepted_at"
        :validation-errors="validationErrors.buying_info_accepted_at"
        is-inline
        has-clear-button
      ></form-field-date-picker>
    </div>
    <div class="column">
      <form-field-date-picker
        label="Contract Date"
        v-model="form.buying_info_contracted_at"
        :validation-errors="validationErrors.buying_info_contracted_at"
        is-inline
        has-clear-button
      ></form-field-date-picker>
    </div>
    <div class="column">
      <form-field-date-picker
        label="Date Closed"
        v-model="form.buying_info_closing_at"
        :validation-errors="validationErrors.buying_info_closing_at"
        is-inline
        has-clear-button
      ></form-field-date-picker>
    </div>
  </div>
</template>

<script>
  import {FormMixin} from "./forms.mixin";

  export default {
    name: "WholesaleSellingInfoForm",
    props: ['formData'],
    mixins: [FormMixin],
    data() {
      return {
        form: {},
        validationErrors: {},
        defaultForm: {
          buying_info_accepted_at: '',
          buying_info_closing_at: '',
          buying_info_contracted_at: '',
        },
      }
    },
    created() {
      // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
      this.form = (this.formData && this.formData.id) ? this.$utils.clone(this.formData) : this.$utils.clone({...this.defaultForm, ...this.formData});
    },
    methods: {
      update() {
        this.form.record_id = this.$store.state.activeRecord.record.id;

        return this.$api.records.updateBuyingInfoDates(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'Buying Info Dates was updated',
              type: 'is-success'
            });

            return res;
          })
      },
      // create() {
      //   return this.$api.buyingInfo.create(this.form)
      //     .then(res => {
      //       this.$buefy.toast.open({
      //         message: 'WholesaleSellingInfo was created',
      //         type: 'is-success'
      //       });
      //
      //       return res;
      //     })
      //   },
      // delete() {
      //   return this.$api.buyingInfo.delete(this.form.id)
      //     .then(res => {
      //       this.$buefy.toast.open({
      //         message: 'WholesaleSellingInfo was archived',
      //         type: 'is-success'
      //       });
      //
      //       return res;
      //     });
      // },
      // restore() {
      //   return this.$api.wholesaleSellingInfos.restore(this.form.id)
      //     .then(res => {
      //       this.$buefy.toast.open({
      //         message: 'WholesaleSellingInfo was restored',
      //         type: 'is-success'
      //       });
      //
      //       return res;
      //     });
      // },
    },
  }
</script>

<style lang="scss" scoped>

</style>
